module.exports = __webpack_public_path__ + "static/media/bakim-duyuru-20240419.ab28fa43.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bakim-duyuru-20240419.jpeg
// module id = 2441
// module chunks = 1